/** الملف الشخصي — الاسم والجوال وتسجيل الخروج. */

import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { color } from '@/design/tokens';
import { Button, Card, SectionTitle } from '@/components/primitives/Primitives';
import { useAuth } from '@/services/auth';
import { useToast } from '@/app/AppShell';

export default function AccountRoute(): JSX.Element {
  const navigate = useNavigate();
  const toast = useToast();
  const { user, logout, updateName } = useAuth();
  const [name, setName] = useState(user?.name ?? '');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    setName(user?.name ?? '');
  }, [user?.name]);

  return (
    <div className="nq-enter" style={{ paddingTop: 36, maxWidth: 560, margin: '0 auto' }}>
      <SectionTitle title="الحساب" />
      <Card>
        <div className="nq-label">رقم الجوال</div>
        <div className="nq-num" dir="ltr" style={{ fontSize: 18, fontWeight: 600, marginTop: 6 }}>
          {user?.phone ?? '—'}
        </div>

        <div style={{ marginTop: 22 }}>
          <label htmlFor="account-name" className="nq-label" style={{ display: 'block', marginBottom: 8 }}>
            الاسم
          </label>
          <input
            id="account-name"
            className="nq-input"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </div>

        <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginTop: 20 }}>
          <Button
            disabled={busy}
            onClick={async () => {
              setBusy(true);
              await updateName(name);
              setBusy(false);
              toast('تم حفظ الاسم');
            }}
          >
            حفظ
          </Button>
          <Button
            variant="ghost"
            onClick={async () => {
              await logout();
              navigate('/');
            }}
          >
            تسجيل الخروج
          </Button>
        </div>
      </Card>

      <p style={{ marginTop: 16, fontSize: 11.5, color: color.micro, lineHeight: 1.7 }}>
        الجلسة صالحة ٣٠ يوماً وتُعاد قراءة صلاحيتك من الخادم مع كل طلب.
      </p>
    </div>
  );
}
